import React from 'react';
import '../styles/support.css';

const Support = () => {
  return (
    <div className="support-wrapper">
      <div className="support-header">
        <div className="support-tab">Support Center</div>
        <p className="support-intro">Need help? Choose a support option below to reach Iword Hosting directly.</p>
      </div>

      <div className="support-tiles">
        <a href="tel:6158527644" className="support-tile">
          <h3>Call Us</h3>
          <p>Speak to a support agent now at <strong>(615) 852-7644</strong>.</p>
        </a>

        <a href="mailto:support@i-word.net" className="support-tile">
          <h3>Email Support</h3>
          <p>Send us your questions at <strong>support@i-word.net</strong>.</p>
        </a>

        <a href="https://account.i-word.net/plugin/support_manager/client_tickets/" className="support-tile">
          <h3>Submit a Ticket</h3>
          <p>Open a ticket and track the status of your support request.</p>
        </a>
      </div>
    </div>
  );
};

export default Support;
